const { Serializer } = require("jsonapi-serializer");

module.exports = {
  purposeSerializer: (meta = {}) =>
    new Serializer("store", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: ["purposeId"]
    })
};
